/** @jsx jsx */

import { Grid, Icon, LegacyButton, Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';
import { useZapUrl } from 'app/developer-v3/hooks';
import { getAppVersionUrl } from 'app/developer-v3/utils/url';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants/url';
import type { SemVer } from 'app/developer-v3/types/version';

const Styles = {
  container: css`
    padding: 20px;
  `,
};

type Props = {
  appId: string;
  version: SemVer;
};

export default function HookTester({ appId, version }: Props) {
  const getZapUrl = useZapUrl();

  return (
    <Surface borderColor="GrayWarm4">
      <aside css={Styles.container}>
        <Text tag="h3" type="Body4">
          The best way to test a rest hook trigger is by using the Zap editor.
        </Text>
        <Text margin="10px 0px 20px" tag="p">
          After you make and test your Zap, check the monitoring data to see if
          the proper events are there.{' '}
        </Text>
        <Grid alignItems="center" columns="repeat(3, auto) 1fr" gap={20}>
          <LegacyButton color="primary" href={getZapUrl()} target="_blank">
            Create a Zap
          </LegacyButton>
          <Icon name="arrowBigRight" size={30} />
          <LegacyButton
            color="secondary"
            href={`${getAppVersionUrl(appId, version)}/monitoring`}
            size="small"
          >
            Monitoring
          </LegacyButton>
        </Grid>
        <Text margin="20px 0px 10px" tag="p">
          Not sure what to do?{' '}
          <LinkWithArrow
            href={`${BASE_DOC_URL_VB}/build/test-integration#how-to-test-new-integrations-inside-zapier`}
            target="_blank"
          >
            Learn more about testing rest hooks
          </LinkWithArrow>
        </Text>
      </aside>
    </Surface>
  );
}
